<div class="d-flex flex-column h-100 placeholder-glow p-3">
    <span class="placeholder col-12" style="min-height: 2rem;"></span>
    <hr class="my-3 p-0">
    <div class="d-flex flex-column h-100 mx-3" style="min-height: 1%;">
        <div class="row my-2" *ngFor="let ri of counter(rows); let ridx=index">
            <div class="col" *ngFor="let ci of counter(cols) let cidx=index">
                <span class="placeholder col-4 my-1" style="min-height: 1.1rem;" *ngIf="withLabel"></span>
                <span class="placeholder col-12 mb-1" style="min-height: 1.3rem;" *ngIf="withLabel"></span>
                <span class="placeholder col-12 my-1" style="min-height: 1.5rem;" *ngIf="!withLabel"></span>
            </div>
        </div>
    </div>
    <hr class="my-3 p-0">
    <div class="text-end">
        <button class="btn btn-primary btn-sm disabled placeholder me-1" style="width: 4rem;"></button>
        <button class="btn btn-secondary btn-sm disabled placeholder" style="width: 4rem;"></button>
    </div>

</div>